import React from "react";
import {
  ICategoryCityLevelPageProps,
  ICategoryListingNormalizedData,
  ICustomerPageState,
  IIdValuePairResponse,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";
import CategoryCityLevelList from "./CategoryCityLevelList";
import UpdateCategoryCityLevelPage from "./UpdateCategoryCityLevelPage";

export default class CategoryCityLevelPage extends React.Component<
  ICategoryCityLevelPageProps,
  ICustomerPageState
> {
  constructor(props: ICategoryCityLevelPageProps) {
    super(props);
    this.state = {
      isUpdatePage: false,
      listPosition: 0,
      searchText: "",
      selectedCity: null,
      selectedCategory: null,
      selectedCategoryParent: null,
    };
  }

  navigateBackToListingPage = (retainState: boolean = true) => {
    const { listPosition, searchText, selectedCity } = this.state;
    this.setState({
      isUpdatePage: false,
      listPosition: retainState ? listPosition : 0,
      searchText: retainState ? searchText : "",
      selectedCity: retainState ? selectedCity : null,
      selectedCategory: null,
      selectedCategoryParent: null,
    });
  };

  renderCategoryUpdatePage = () => {
    const {
      selectedCity,
      selectedCategory,
      selectedCategoryParent,
    } = this.state;
    return (
      <UpdateCategoryCityLevelPage
        isLoading={this.props.isLoading}
        isError={this.props.isError}
        error={this.props.error}
        isCategoryUpdated={this.props.isCategoryUpdated}
        city={selectedCity}
        category={selectedCategory}
        categoryParent={selectedCategoryParent}
        fetchCategoryProducts={this.props.fetchCategoryProducts}
        categoryProductList={this.props.categoryProductList}
        reorderCategoryProducts={this.props.reorderCategoryProducts}
        updateCategory={this.props.updateCategory}
        backButtonHandler={this.navigateBackToListingPage}
      />
    );
  };

  toggleUpdateCategoryPage = (
    searchText: string = "",
    currentScroll: number = 0,
    selectedCity: IIdValuePairResponse | null,
    selectedCategory: ICategoryListingNormalizedData,
    selectedCategoryParent?: ICategoryListingNormalizedData
  ) => {
    this.setState({
      isUpdatePage: !this.state.isUpdatePage,
      listPosition: currentScroll,
      searchText: searchText,
      selectedCity: selectedCity,
      selectedCategory: selectedCategory,
      selectedCategoryParent: selectedCategoryParent,
    });
  };

  renderCategoryListing = () => {
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Categories" isMainHeading={true} />
        </section>
        <CategoryCityLevelList
          isLoading={this.props.isLoading}
          isError={this.props.isError}
          error={this.props.error}
          pagination={this.props.pagination}
          isCategoryUpdated={this.props.isCategoryUpdated}
          fetchCities={this.props.fetchCities}
          citiesList={this.props.cityList}
          fetchCategories={this.props.fetchCategories}
          categoryList={this.props.categoryList}
          retainedListPosition={this.state.listPosition}
          retainedSearchText={this.state.searchText}
          retainedSelectedCity={this.state.selectedCity}
          updatePageHandler={this.toggleUpdateCategoryPage}
        />
      </>
    );
  };

  render() {
    return (
      <div>
        {this.state.isUpdatePage
          ? this.renderCategoryUpdatePage()
          : this.renderCategoryListing()}
      </div>
    );
  }
}
